var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container mb-25px" }, [
    _c("div", { staticClass: "progress-title" }, [
      _vm._v("\n    distance\n  ")
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "progress-section d-flex justify-content-between align-items-center"
      },
      [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "progress-time" }, [
          _vm._v(_vm._s(_vm.distance.company_to_pickup) + " miles")
        ])
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "progress-section d-flex justify-content-between align-items-center"
      },
      [
        _vm._m(1),
        _vm._v(" "),
        _c("div", { staticClass: "progress-time" }, [
          _vm._v(_vm._s(_vm.distance.dropoff_to_company) + " miles")
        ])
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "progress-section d-flex justify-content-between align-items-center"
      },
      [
        _vm._m(2),
        _vm._v(" "),
        _c("div", { staticClass: "progress-time" }, [
          _vm._v(_vm._s(_vm.distance.deadhead) + " miles")
        ])
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "progress-section d-flex justify-content-between align-items-center"
      },
      [
        _vm._m(3),
        _vm._v(" "),
        _c("div", { staticClass: "progress-time" }, [
          _vm._v(_vm._s(_vm.distance.route) + " miles")
        ])
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "progress-section d-flex justify-content-between align-items-center"
      },
      [
        _vm._m(4),
        _vm._v(" "),
        _c("div", { staticClass: "progress-time" }, [
          _vm._v(_vm._s(_vm.distance.total) + " miles")
        ])
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "d-flex align-items-center" }, [
      _c("div", { staticClass: "progress-status d-flex flex-column" }, [
        _c("span", { staticClass: "progress-text" }, [
          _vm._v("Parking to Pickup")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "d-flex align-items-center" }, [
      _c("div", { staticClass: "progress-status d-flex flex-column" }, [
        _c("span", { staticClass: "progress-text" }, [
          _vm._v("Delivery to Pickup")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "d-flex align-items-center" }, [
      _c("div", { staticClass: "progress-status d-flex flex-column" }, [
        _c("span", { staticClass: "progress-text" }, [
          _vm._v("Deadhead (when truck is empty)")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "d-flex align-items-center" }, [
      _c("div", { staticClass: "progress-status d-flex flex-column" }, [
        _c("span", { staticClass: "progress-text" }, [
          _vm._v("Pickup to Delivery (all addresses)")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "d-flex align-items-center" }, [
      _c("div", { staticClass: "progress-status d-flex flex-column" }, [
        _c("span", { staticClass: "progress-text" }, [
          _vm._v("Parking to Parking")
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-262eacb6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-262eacb6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Distance.vue
// module id = null
// module chunks = 